/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { DataGrid, useGridApiContext, useGridState } from '@mui/x-data-grid';
import './styles.css';
import PropTypes from 'prop-types';
import {
    Stack,
    Select,
    MenuItem,
    Checkbox,
    InputLabel,
    FormControl,
    IconButton,
    TextField,
    Pagination,
    Grid,
    PaginationItem,
    Button,
    Dialog,
    DialogTitle
} from '@mui/material';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { Link } from 'react-router-dom';
import { CSVLink } from 'react-csv';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import { format } from 'date-fns';
import Cookies from 'js-cookie';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Create, Clear } from '@mui/icons-material';
import ClearIcon from '@material-ui/icons/Clear';
import SearchIcon from '@material-ui/icons/Search';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
import LoadingButton from '@mui/lab/LoadingButton';
import DateRange from '../../components/DateRange';
import InstanceName from '../../components/InstanceName';
import useStyles from './styles';
import {
    getIncidents,
    getIncidentsToExport,
    deleteIncident
} from '../../redux/Actions/incident.action';
import Notifications from '../notifications/Notifications';

const exportToExcel = (data, filename) => {
    const columns = ['ID', 'Title', 'Reported', 'Status', 'Services Affected'];
    const rows = data.map((row) => columns.map((col) => row[col]));
    const ws = XLSX.utils.aoa_to_sheet([columns, ...rows]);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Incidents');
    const buf = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    saveAs(new Blob([buf], { type: 'application/octet-stream' }), `${filename}.xlsx`);
};
const escapeRegExp = (value) => value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');

function CustomPagination(props) {
    const apiRef = useGridApiContext();
    const [state] = useGridState(apiRef);
    const classes = useStyles();

    useEffect(() => {
        apiRef.current.setPage(props.page);
    }, [props.page, apiRef]);

    return (
        <div className={classes.customPagination}>
            {state.pagination.rowCount ? (
                <div>
                    <span className={classes.showPaginationDesc}>
                        Showing {state.pagination.page * 10 + 1} to&nbsp;
                        {(state.pagination.page + 1) * 10} of&nbsp;
                        {state.pagination.rowCount} entries
                    </span>
                    <Pagination
                        className={classes.root}
                        color="primary"
                        count={state.pagination.pageCount}
                        page={state.pagination.page + 1}
                        onChange={(event, value) => apiRef.current.setPage(value - 1)}
                        ariant="outlined"
                        shape="rounded"
                        hideNextButton={false}
                        variant="outlined"
                        renderItem={(item) => (
                            <PaginationItem {...item} className={classes.pageItem} variant="text" />
                        )}
                    />
                </div>
            ) : (
                ''
            )}
        </div>
    );
}

const statusRowComp = (params) => (
    <div className="statusCompCont">
        <span className="statusRow">{params.value}</span>
    </div>
);

const servicesRowComp = (params) => (
    <div>
        {/* <span className="statusRow">{params.value}</span> */}
        {params.value && params.value.length ? (
            <ul className="servcieCompCont">
                {params.value.map((i, index) => (
                    <li key={index}>
                        <FiberManualRecordIcon className="serviceList" />
                        {i}
                    </li>
                ))}
            </ul>
        ) : (
            <div />
        )}
    </div>
);

const idRowComp = (params) => <span title={params.row.id}>{params.row.id}</span>;

const titleRowComp = (params) => <div id="subjectcomp">{params.row.title}</div>;

const csvLink = React.createRef();
const incidentStatus = ['New', 'Identified', 'Investigating', 'Monitoring', 'Resolved'];

const QuickSearchToolbar = (props) => {
    const classes = useStyles(props.theme);
    const [isSearchOpen, setSearchOpen] = useState(false);
    const [searchText, setSearchText] = useState('');
    const { setPage, setSearchString } = props;
    const { debounceRate } = useSelector((state) => state.constants.settings);

    useEffect(() => {
        const timeoutId = setTimeout(() => setSearchString(escapeRegExp(searchText)), debounceRate);
        setPage(0);
        return () => clearTimeout(timeoutId);
    }, [searchText, setSearchString, setPage]);

    return (
        <div className={classes.root}>
            {!isSearchOpen ? (
                <strong>
                    {'ID '}
                    <IconButton
                        aria-haspopup="true"
                        color="inherit"
                        onClick={() => {
                            setSearchOpen(true);
                        }}
                    >
                        <FontAwesomeIcon
                            icon={faSearch}
                            className={classes.tableSearchIcon}
                            classes={{ root: classes.headerIcon }}
                        />
                    </IconButton>
                </strong>
            ) : (
                <TextField
                    variant="standard"
                    value={searchText}
                    onChange={(e) => {
                        setSearchText(e.target.value);
                    }}
                    placeholder="Search"
                    className={classes.searchTextField}
                    autoFocus
                    InputProps={{
                        classes: {
                            input: classes.resize
                        },
                        startAdornment: <SearchIcon fontSize="small" />,
                        endAdornment: (
                            <IconButton
                                title="Clear"
                                aria-label="Clear"
                                size="small"
                                onClick={() => {
                                    setSearchText('');
                                    setSearchOpen(false);
                                }}
                            >
                                <ClearIcon fontSize="small" />
                            </IconButton>
                        )
                    }}
                />
            )}
        </div>
    );
};

function QuickFilters(props) {
    const classes = useStyles();
    const ref = useRef();
    useEffect(() => {
        const checkIfClickedOutside = (e) => {
            if (props.openDateRangeMenu && ref.current && !ref.current.contains(e.target)) {
                props.setOpenDateRangeMenu(false);
            }
        };
        document.addEventListener('mousedown', checkIfClickedOutside);
    }, [props]);
    return (
        <div>
            <Grid container className={classes.gridContButtons}>
                <div className={classes.filterList}>
                    <Grid item xs={12} sm={4}>
                        <FormControl id="exportFilters" className={classes.incidentForm}>
                            <Select
                                value=""
                                onOpen={props.fetchIncidentData}
                                className={classes.width150}
                                id="demo-simple-select1"
                                displayEmpty
                                inputProps={{
                                    'aria-label': 'Without label',
                                    classes: {
                                        icon: classes.selectIcon
                                    }
                                }}
                            >
                                <MenuItem value="" className={classes.dnone}>
                                    <ExitToAppIcon />
                                    <span>Export</span>
                                </MenuItem>
                                <MenuItem value="csv">
                                    <CSVLink
                                        data={props.incidentsToExport}
                                        style={{
                                            color: 'inherit',
                                            textDecoration: 'none',
                                            width: '100px'
                                        }}
                                        ref={csvLink}
                                        filename={`Incidents_${props.instanceName}`}
                                    >
                                        CSV
                                    </CSVLink>
                                </MenuItem>
                                <MenuItem className={classes.width150} value="excel">
                                    <button
                                        type="button"
                                        className={classes.width150}
                                        style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}
                                        onClick={() =>
                                            exportToExcel(
                                                props.incidentsToExport,
                                                `Incidents_${props.instanceName}`
                                            )
                                        }
                                    >
                                        Excel
                                    </button>
                                </MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <FormControl className={classes.formSet}>
                            <InputLabel
                                id="demo-simple-select2"
                                style={{ top: props.value.length ? '17px' : '0px' }}
                            >
                                Status
                            </InputLabel>
                            <Select
                                className={classes.selectFilters}
                                labelId="demo-simple-select-label2"
                                id="demo-simple-select2"
                                onChange={props.onChange}
                                multiple
                                value={props.value}
                                renderValue={(data) => (
                                    <div>
                                        {incidentStatus.length === data.length
                                            ? 'All'
                                            : data.join(', ')}
                                    </div>
                                )}
                            >
                                <MenuItem
                                    value="All"
                                    classes={{
                                        root:
                                            incidentStatus.length <= props.value.length
                                                ? classes.selectedAll
                                                : classes.selectedNone
                                    }}
                                >
                                    <Checkbox
                                        checked={incidentStatus.length === props.value.length}
                                    />
                                    All
                                </MenuItem>
                                {incidentStatus.map((status, index) => (
                                    <MenuItem value={status} key={index}>
                                        <Checkbox checked={props.value.indexOf(status) > -1} />
                                        {status}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <FormControl className={classes.formSet}>
                            <InputLabel
                                id="demo-simple-select3"
                                style={{ top: props.dateRange ? '17px' : '0px' }}
                            >
                                Date Range
                            </InputLabel>
                            <Select
                                className={classes.selectFiltersDate}
                                id="demo-simple-select3"
                                value={props.dateRange}
                                onChange={() => props.setOpenDateRangeMenu(false)}
                                style={{ height: '54px' }}
                                open={props.openDateRangeMenu}
                                onOpen={() => props.setOpenDateRangeMenu(true)}
                                ref={ref}
                            >
                                <MenuItem
                                    value={props.dateRange}
                                    key={props.dateRange}
                                    className={classes.dnone}
                                >
                                    {props.dateRange}
                                </MenuItem>
                                <DateRange
                                    filterRowsOnDate={props.filterRowsOnDate}
                                    range={props.dates}
                                    dateRange={props.dateRange}
                                />
                            </Select>
                            <svg
                                onClick={() => props.setOpenDateRangeMenu(true)}
                                xmlns="http://www.w3.org/2000/svg"
                                height="24px"
                                viewBox="0 0 24 24"
                                width="24px"
                                fill="#707070"
                                className={classes.calenderSvg}
                            >
                                <path d="M0 0h24v24H0V0z" fill="none" />
                                <path d="M7 11h2v2H7v-2zm14-5v14c0 1.1-.9 2-2 2H5c-1.11 0-2-.9-2-2l.01-14c0-1.1.88-2 1.99-2h1V2h2v2h8V2h2v2h1c1.1 0 2 .9 2 2zM5 8h14V6H5v2zm14 12V10H5v10h14zm-4-7h2v-2h-2v2zm-4 0h2v-2h-2v2z" />
                            </svg>
                        </FormControl>
                    </Grid>
                </div>
            </Grid>
        </div>
    );
}

QuickFilters.propTypes = {
    onChange: PropTypes.func.isRequired,
    value: PropTypes.array.isRequired,
    filterRowsOnDate: PropTypes.func.isRequired,
    dateRange: PropTypes.string.isRequired,
    fetchIncidentData: PropTypes.func.isRequired
};

export default function DataTable() {
    const dispatch = useDispatch();
    const classes = useStyles();
    const getInstance = useSelector((state) => state.clientReducer);
    const getIncidentData = useSelector((state) => state.incidentReducer);
    const [dataRows, setDataRows] = useState([]);
    const [rowCount, setRowCount] = useState(0);
    const [page, setPage] = React.useState(0);
    const [pageSize] = React.useState(10);
    const [incidentsToExport, setIncidentsToExport] = useState([]);
    const [statusFilter, setStatusFilter] = useState(incidentStatus);
    const [rangeFilter, setRangeFilter] = useState('All Time');
    const [dates, setDates] = useState({
        startDate: new Date(0),
        endDate: new Date()
    });
    const [tenantId, setTenantId] = useState(
        Cookies.get('tenantId') ? Cookies.get('tenantId') : ''
    );
    const [sortModel, setSortModel] = useState([{ field: 'reportedAt', sort: 'desc' }]);
    const [searchString, setSearchString] = useState('');
    const [openDateRangeMenu, setOpenDateRangeMenu] = useState('');
    const [loading, setLoading] = React.useState(false);
    const [instanceName, setInstanceName] = useState();
    const [selectedValue, setSelectedValue] = useState('');
    const [open, setOpen] = useState(false);

    const filterRowsOnDateChange = (event) => {
        setRangeFilter(event.label);
        setOpenDateRangeMenu(false);
        setDates({
            startDate: event.startDate,
            endDate: event.endDate
        });
        if (rangeFilter !== event.label) setPage(0);
    };

    const toggleAllCheckbox = (event) => {
        if (event.currentTarget.checked) setStatusFilter(incidentStatus);
        else setStatusFilter([]);
    };

    const fetchIncidentData = async () => {
        dispatch(
            getIncidentsToExport({
                status: statusFilter.indexOf('All') > -1 ? incidentStatus : statusFilter,
                startDate: dates.startDate,
                endDate: dates.endDate,
                tenantId,
                sort: sortModel.length && sortModel[0].sort === 'desc' ? -1 : 1,
                searchString: searchString || ''
            })
        ).then((data) => {
            if (data[0].documents.length)
                data[0].documents = data[0].documents.map((f) => ({
                    ID: f.id,
                    Title: f.title,
                    Reported: format(new Date(f.reportedAt), 'd MMMM y | HH:mm:ss a'),
                    Status: f.status,
                    'Services Affected': f.servicesAffected
                        .map((f) => (f.service ? f.service : f))
                        .join(', ')
                }));
            setIncidentsToExport(data[0].documents);
        });
    };

    const renderButtons = (params) => (
        <div className={classes.incidentActions}>
            <Button
                component={Link}
                to={{
                    pathname: `/app/incidents/edit`,
                    state: params.row
                }}
                variant="text"
                className={classes.editButton}
                startIcon={<Create className={classes.editIcon} />}
                title="Edit"
            />
            <Button
                variant="text"
                onClick={() => {
                    setOpen(true);
                    setSelectedValue(params.row._id);
                }}
                startIcon={<Clear className={classes.editIcon} />}
                title="Delete"
            />
        </div>
    );

    const columns = [
        {
            field: 'id',
            headerName: 'ID',
            minWidth: 100,
            sortable: false,
            flex: 1,
            renderCell: idRowComp,
            renderHeader: () => (
                <QuickSearchToolbar
                    theme
                    setPage={setPage}
                    setRows={setDataRows}
                    incidents={dataRows}
                    setSearchString={setSearchString}
                />
            )
        },
        {
            field: 'title',
            headerName: 'Title',
            sortable: false,
            flex: 3,
            minWidth: 150,
            renderCell: titleRowComp
        },
        {
            field: 'reportedAt',
            headerName: 'Reported',
            minWidth: 210,
            valueFormatter: (params) => format(new Date(params.value), 'd MMMM y | HH:mm:ss a'),
            sortIcon: { opacity: '0.6 !important' },
            flex: 2
        },
        {
            field: 'status',
            headerName: 'Status',
            minWidth: 109,
            editable: true,
            valueOptions: incidentStatus,
            renderCell: statusRowComp,
            sortable: false,
            flex: 1
        },
        {
            field: 'servicesAffected',
            headerName: 'Services Affected',
            // description: 'This column has a value getter and is not sortable.',
            sortable: false,
            renderCell: servicesRowComp,
            minWidth: 160,
            valueGetter: (params) => params.value.map((f) => (f.service ? f.service : f)),
            flex: 1.5
        },
        {
            field: 'action',
            headerName: 'Action',
            filter: false,
            minWidth: 65,
            sortable: false,
            flex: 0.8,
            renderCell: renderButtons
        }
    ];

    const ConfirmDialog = (props) => {
        const { onClose, selectedValue, open } = props;
        const [loading, setLoadingBtn] = React.useState(false);

        const handleClose = (event, reason) => {
            if (reason !== 'backdropClick') {
                onClose(selectedValue);
            }
        };

        const handleDelete = async () => {
            setLoadingBtn(true);
            try {
                await deleteIncident(selectedValue);
                setLoadingBtn(false);
                setOpen(false);
                toast.success('Incident removed successfully');
                getAllIncidents();
            } catch (error) {
                setLoadingBtn(false);
                toast.error('Error in removing incident');
            }
        };

        return (
            <Dialog onClose={handleClose} open={open} disableEscapeKeyDown>
                <DialogTitle className={classes.popupTitle}>
                    Are you sure to delete
                    <br />
                    the incident?
                </DialogTitle>
                <Grid container className={classes.pb30}>
                    <span className={classes.popupButtonGrid}>
                        <Button variant="outlined" onClick={handleClose} className={classes.mx10}>
                            Cancel
                        </Button>
                        <LoadingButton
                            onClick={handleDelete}
                            loading={loading}
                            variant="outlined"
                            className={classes.mx10}
                        >
                            Remove
                        </LoadingButton>
                    </span>
                </Grid>
            </Dialog>
        );
    };

    ConfirmDialog.propTypes = {
        onClose: PropTypes.func.isRequired,
        open: PropTypes.bool.isRequired
    };

    const getAllIncidents = () => {
        // Only make API call if tenantId is available
        if (!tenantId) {
            return;
        }
        dispatch(
            getIncidents({
                status: statusFilter.indexOf('All') > -1 ? incidentStatus : statusFilter,
                startDate: dates.startDate,
                endDate: dates.endDate,
                tenantId,
                pageNo: page,
                resultsPerPage: pageSize,
                sort: sortModel.length && sortModel[0].sort === 'desc' ? -1 : 1,
                // search: search || false,
                searchString: searchString || ''
            })
        );
    };

    useEffect(() => {
        // Only call getAllIncidents if tenantId is available
        if (tenantId) {
            setLoading(true);
            const getAll = getAllIncidents;
            getAll();
        }
    }, [dispatch, dates, statusFilter, tenantId, page, pageSize, sortModel, searchString]);
    useEffect(() => {
        // Only update tenantId if clientInfo.tenantId exists and is different from current tenantId
        // This prevents setting tenantId to undefined when clientInfo is initially empty
        if (getInstance.clientInfo && getInstance.clientInfo.tenantId && getInstance.clientInfo.tenantId !== tenantId) {
            setTenantId(getInstance.clientInfo.tenantId);
            setInstanceName(getInstance.clientInfo.name);
            setPage(0);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [getInstance.clientInfo]);
    useEffect(() => {
        setDataRows(
            getIncidentData.incidentData && getIncidentData.incidentData.length
                ? getIncidentData.incidentData[0].documents
                : [],
            setLoading(false)
        );
        setRowCount(
            getIncidentData.incidentData &&
                getIncidentData.incidentData.length &&
                getIncidentData.incidentData[0].total.length
                ? getIncidentData.incidentData[0].total[0].count
                : 0,
            setLoading(false)
        );
    }, [getIncidentData.incidentData]);

    return (
        <div className={classes.incidentListDiv}>
            <Grid container className={classes.nameResp}>
                <InstanceName />
            </Grid>
            <DataGrid
                className={classes.gridClass}
                rows={dataRows}
                columns={columns}
                pageSize={pageSize}
                // rowsPerPageOptions={[5, 10, 20]}
                pagination
                autoHeight
                onPageChange={(newPage) => setPage(newPage)}
                rowCount={rowCount}
                hideFooter={rowCount <= pageSize}
                paginationMode="server"
                components={{
                    Toolbar: QuickFilters,
                    Pagination: CustomPagination,
                    NoRowsOverlay: () => (
                        <Stack
                            height="100%"
                            alignItems="center"
                            justifyContent="center"
                            style={{ marginTop: '200px' }}
                        >
                            No Incidents Found
                        </Stack>
                    ),
                    NoResultsOverlay: () => (
                        <Stack
                            height="100%"
                            alignItems="center"
                            justifyContent="center"
                            style={{ marginTop: '200px' }}
                        >
                            No Incidents Found
                        </Stack>
                    )
                }}
                componentsProps={{
                    toolbar: {
                        value: statusFilter,
                        toggleAllCheckbox,
                        onChange: (event) => {
                            if (event.target.value[event.target.value.length - 1] === 'All') {
                                setStatusFilter(
                                    statusFilter.length === incidentStatus.length
                                        ? []
                                        : incidentStatus
                                );
                            } else setStatusFilter(event.target.value);
                            setPage(0);
                        },
                        filterRowsOnDate: (event) => filterRowsOnDateChange(event),
                        dateRange: rangeFilter,
                        fetchIncidentData,
                        incidentsToExport,
                        dates,
                        openDateRangeMenu,
                        setOpenDateRangeMenu,
                        instanceName
                    },
                    pagination: {
                        page
                    }
                }}
                isRowSelectable={() => false}
                sortingMode="server"
                sortModel={sortModel}
                onSortModelChange={(newModel) => setSortModel(newModel)}
                sortingOrder={['desc', 'asc']}
                disableColumnMenu
                loading={loading}
            />
            <ConfirmDialog
                open={open}
                selectedValue={selectedValue}
                onClose={() => setOpen(false)}
            />
            <Notifications />
        </div>
    );
}
